interface Props {
  [key: string]: any
}

export default function MenuAltIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 24 18" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M1.5 1.5H22.5"
        stroke="none"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M1.5 9H16.5"
        stroke="none"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M1.5 16.5H10.5"
        stroke="none"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </svg>
  )
}
